export default {
  gallery: 'Gallery',
  myCreations: 'My Creations',
  infographicTemplates: 'Infographic Templates',
  pricing: 'Pricing',
  institutions: 'Institutions',
  customServices: 'Custom Design',
  aboutUs: 'About Us',
  blog: 'Blog',
  template_page_title: {
    'Graphical Abstracts': 'Graphical Abstract Templates: Visual Abstract Templates',
    'Slides Presentations': 'Scientific Presentation Templates: Free Presentation Templates',
    Infographics: 'Infographic Templates - Free Download',
    Posters: 'Scientific Poster Templates: Find Academic & Research Posters',
  },
  template_page_description: {
    'Graphical Abstracts':
      'Find graphical abstract templates easily with Mind the Graph. Our visual templates help you share complex research in a clear, compelling way. Create stunning visuals that make your work stand out.',
    'Slides Presentations':
      'Find scientific presentation templates easily with Mind the Graph. Our professionally designed slides help researchers communicate complex findings visually. ',
    Infographics:
      'Download free infographic templates designed for scientists. Mind the Graph offers customizable, professional infographics that help communicate complex information visually.',
    Posters:
      'Find scientific poster templates easily with Mind the Graph. Our professionally designed academic and research poster templates help researchers communicate complex findings visually. ',
  },
};
